import { Col, Form, InputNumber } from 'antd';
import numeral from 'numeral';
import type { IField } from '../data';
import styles from '../styles.less';

const { Item } = Form;

const Number_: React.FC<IField> = (props) => {
    const {
        name,
        span = 8,
        label,
        rules,
        placeholder,
        disabled,
        min = 0,
        max,
        percentage,
        xs,
        lg,
        marginBottom = 0,
        style,
        addonAfter,
        addonBefore,
        hidden = false,
        onChange,
        size,
        currency = false,
        controls,
        defaultPrecision = 4,
        readOnly,
        t,
    } = props;

    const grid = {
        xs: xs || span,
        lg: lg || span,
        span: span,
    };

    const styling = {
        style: marginBottom ? { marginBottom } : {},
    };

    return (
        <Col key={name} {...grid}>
            <Item label={t?.(label)} hidden={hidden} name={name} rules={rules} {...styling} style={style}>
                <InputNumber
                    size={size}
                    placeholder={t?.(placeholder)}
                    className={styles.fullWidth}
                    style={{ width: '100%' }}
                    onChange={onChange}
                    min={min.toString()}
                    max={percentage ? '1' : max?.toString()}
                    disabled={disabled}
                    addonBefore={addonBefore}
                    controls={controls}
                    readOnly={readOnly}
                    key={String(currency)}
                    addonAfter={addonAfter}
                    formatter={
                        percentage
                            ? (value: any) => {
                                  if (value) return `${numeral(Number(value) * 100).format('0,0.[0000]')}%`;
                                  return '';
                              }
                            : !!currency
                            ? (value) => {
                                  return `${currency} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                              }
                            : undefined
                    }
                    parser={
                        percentage
                            ? (value: any) => {
                                  return parseFloat(value.replace('%', '')) / 100;
                              }
                            : !!currency
                            ? (value: any) => value!.replace(currency || '', '').replace(/\$\s?|(,*)/g, '')
                            : undefined
                    }
                    precision={percentage ? 6 : defaultPrecision}
                    step={percentage ? '0.00001' : 1}
                />
            </Item>
        </Col>
    );
};

export default Number_;
